import {
  ElementController,
  debounce,
  selectSingleChild,
  selectSingle,
} from 'js-common';

/**
 * Toggled navigation menu
 *
 * @extends {ElementController}
 */
export default class Menu extends ElementController {
  static id = 'Menu';

  /**
   * DOM loaded, initialize elements and bind events.
   */
  init() {
    // The primary menu will switch to a toggle version on smaller screens.
    this.menuToggle = selectSingle('[data-menu-toggle]');
    this.menuToggleStyle = window.getComputedStyle(this.menuToggle);
    this.menuList = selectSingleChild(this.getRoot(), 'ul');

    this.on(this.getRoot(), 'click', this.handleRootClick);
    this.checkMenuToggleState();
    this.on(window, 'resize', debounce(this.handleResize, 200));
  }

  /**
   * Check if the menu is currently in its toggled state.
   */
  checkMenuToggleState = () => {
    this.isToggledMenu = this.menuToggleStyle.display !== 'none';
  };

  /**
   * Check toggled menu state on resize.
   */
  handleResize = () => {
    this.checkMenuToggleState();
  };

  /**
   * Close the toggled menu when clicking on the 'background overlay', which is
   * actually just the menu background.
   *
   * @param {object} e - Click event.
   */
  handleRootClick = (e) => {
    if (
      this.isToggledMenu &&
      // Not clicking on something inside the list
      !this.menuList.contains(e.target)
    ) {
      this.menuToggle.click();
    }
  };
}
